import {HttpClient, HttpHeaders} from '@angular/common/http';
import 'rxjs/add/operator/catch';
import {Injectable} from '@angular/core';
import {ApiEndpoints} from '../ApiEndpoints';
import {ApiUtils} from '../ApiUtils';
import 'rxjs/add/operator/map';
import {Partenaire} from '../../model/partenaire';
// import {SharedMethods} from "../../../util/sharedMethods";
// import {NetworkService} from "../../../util/NetworkService";

import { SharedMethods } from '../../../../util/sharedMethods-service';
import { plainToClass } from 'class-transformer';
import { Company } from '../../model/company';


@Injectable()
export class CompanyService {


  iSconnecting: boolean = false;
  httpClient: any;

  constructor(public apiEndpoints: ApiEndpoints, public http: HttpClient,
              public apiUtils: ApiUtils,
              // public networkService:NetworkService,
              public sharedMethods: SharedMethods,
              ) { }

    /* this.http.get(this.apiEndpoints.URL_GET_PRODUITS,
      {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
      .subscribe(data => {
          // resolve(data);
          alert(JSON.stringify(data));
          // alert('ok');
        },
        err => {
          // console.log(err);
          alert(JSON.stringify(err));
    }); */



  save(company: Company) {

      this.iSconnecting = true;
      const pat = {
        name: company.name,
        contact: company.contact,
        email: company.email,
        pays: company.pays,
        ville: company.ville,
        quatier: company.quatier,
        rue: company.rue,
        dateClotureOp: this.sharedMethods.converStringToDatetime(company.date_cloture_op),
        editOrderPriceInvoice: company.edit_order_price_invoice,
        popup: company.popup,
        factureLivraison: company.facture_livraison,
        factureEcheance: company.facture_echeance,
        factureReglement: company.facture_reglement,
        tva: company.tva,
        activeTva: company.active_tva,
        impressionLogo: company.impression_logo,
        commandStockInsuffisant: company.command_stock_insuffisant,
        controleQteLivrsonEtRetour: company.controle_qte_livrson_et_retour,
        editDateFacturation: company.edit_date_facturation,
        logoutTimes: company.logout_times,
        remiseFacture: company.remise_facture,
        devise: company.devise,
        activateRetour: company.activate_retour,
        impressionEntete: company.impression_entete,
        limitationCreance: company.limitation_creance,
        gestionCompteDepot: company.gestion_compte_depot,
        editDateFlux: company.edit_date_flux,
        defaultTresorAccount: company.default_tresor_account,
        descriptionEntreprise: company.description_entreprise,
        depotAccount: company.depot_account,
        gestionEmballage: company.gestion_emballage,
        gestionTaxes: company.gestion_taxes,
        bp: company.bp,
        numContribuable: company.num_contribuable,
        rc: company.rc,

      };

      if (company.id !== 0) {

        this.iSconnecting = true;

        return new Promise<Company>(resolve => {
          this.http.patch(this.apiEndpoints.GET_URL_PATCH_COMPANY(company.id), pat,
            {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
            .subscribe((data: Company) => {

                resolve(data);
                this.iSconnecting = false;

              },
              err => {
                this.sharedMethods.errorApiShow(err.error.code, err.error.message);
                // alert(JSON.stringify(err));
                this.iSconnecting = false;
              });
        });

      } else {

        return new Promise<Company>(resolve => {
          this.http.post(this.apiEndpoints.GET_URL_POST_COMPANY, pat,
            {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
            .subscribe((data: Company) => {

                resolve(data);
                this.iSconnecting = false;

              },
              err => {
                this.sharedMethods.errorApiShow(err.error.code, err.error.message);
                // alert(JSON.stringify(err));
                this.iSconnecting = false;
              });
        });

      }

    }

    /* deletePartner(partner: Partenaire, type: string) {
      this.iSconnecting = true;
      return new Promise(resolve => {
        this.http.delete(this.apiEndpoints.GET_URL_DELETE_PARTNER(partner.id),
          {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
          .subscribe(data => {

            this.getPartner(type).then( () => {

              this.getAllPartner().then( () => {
                resolve(data);
                this.iSconnecting = false;
              });

            });

            },
            err => {
              this.sharedMethods.errorApiShow(err.error.code, err.error.message);
              // alert(JSON.stringify(err));
              this.iSconnecting = false;
            });
      });


    } */

    savelogo(company: Company) {

      this.iSconnecting = true;

      const formData: FormData = new FormData();

      if ( company.selectedLogoFile !== undefined)
      formData.append( 'filedata', company.selectedLogoFile);

      /* const httpOptions = {
        headers: new HttpHeaders({
        'X-Auth-Token': this.apiUtils.CURRENT_ACCESS_TOKEN,
        'X-Tenant': this.apiUtils.TENANTDB,
        }).delete('Content-Type'),
      }; */

      const httpOptions = {
        headers: new HttpHeaders({
          // 'X-Auth-Token': localStorage.getItem('token')
          'X-Auth-Token': this.apiUtils.CURRENT_ACCESS_TOKEN,
        }),
      };


      return new Promise<Company>(resolve => {
        this.http.post(this.apiEndpoints.GET_URL_COMPANY_UPDATE_LOGO(company.id), formData,
        {headers: this.apiUtils.BASIC_API_REQUEST_HEADER().delete('Content-Type')})
        .subscribe((data: Company) => {
 
              resolve(data);

              this.iSconnecting = false;

            },
            err => {

              this.sharedMethods.errorApiShow(err.error.code, err.error.message);
              // alert(JSON.stringify(err));
              this.iSconnecting = false;

        });

      });

    }




}
